import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomProductViewComponent } from './product-view.component';
import { IconModule } from '@spartacus/storefront';

@NgModule({
  declarations: [CustomProductViewComponent],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,

    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        ProductViewMode: {
          component: CustomProductViewComponent,
        },
      },
    }),
  ],
})
export class ProductViewModule {}
